import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  ConfirmButton,
  Row,
  CancelButton,
  Input,
  Label,
  InputContainer,
  CheckboxContainer,
  CheckboxText,
  CheckboxTextLight,
  CheckboxTextContainer,
} from "./CreatePlaylistModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPlaylistPending } from "../../store/slices/playlist/slice";
import { createPlaylist } from "../../store/slices/playlist/asyncThunk";
import { toast } from "sonner";

import LottieIcon from "../../components/LottieIcon/LottieIcon";
import checkboxAnimation from "../../assets/animations/radioButton.json";

const MIN_PLAYLIST_NAME_LENGTH = 5;

const CreatePlaylistModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const [isPublic, setIsPublic] = useState(false);
  const [playlistName, setPlaylistName] = useState("");

  const isLoading = useSelector(selectPlaylistPending).createPlaylist;
  const isNameValid = playlistName.trim().length >= MIN_PLAYLIST_NAME_LENGTH;

  useLockBodyScroll(isOpen);

  const handleConfirm = () => {
    if (!isNameValid) {
      toast.error("Playlist name must be at least 5 characters long");
      return;
    }

    dispatch(createPlaylist({ isPublic, name: playlistName.trim() }))
      .unwrap()
      .then(() => {
        toast.info("Playlist created successfully");
        setIsPublic(false);
        setPlaylistName("");
        onClose();
      })
      .catch(() => {
        toast.error("Error occurred while creating playlist");
      });
  };

  const handleCancel = () => {
    if (!isLoading) {
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3600 }}
    >
      <ModalContainer>
        <ModalContent>
          <Row>
            <ModalTitle>Create Playlist</ModalTitle>
            <CloseButton onClick={handleCancel}>
              <CloseSvg width={20} height={20} />
            </CloseButton>
          </Row>

          <InputContainer>
            <Label>Playlist Name</Label>
            <Input
              value={playlistName}
              onChange={(e) => setPlaylistName(e.target.value)}
              placeholder="Enter a name for your playlist"
            />
            {playlistName && !isNameValid && (
              <CheckboxTextLight style={{ marginTop: -2 }}>
                Playlist name must be at least 5 characters long
              </CheckboxTextLight>
            )}

            <CheckboxContainer
              onClick={() => {
                setIsPublic(!isPublic);
              }}
            >
              <LottieIcon
                animationData={checkboxAnimation}
                speed={2}
                trigger="toggle-reverse"
                isActive={isPublic}
                onActiveChange={() => {
                  setIsPublic(!isPublic);
                }}
                onClick={() => {
                  setIsPublic(!isPublic);
                }}
                strokeColor={"#4D9DFF"}
                size={24}
              />
              <CheckboxTextContainer>
                <CheckboxText>Make this playlist public</CheckboxText>
                <CheckboxTextLight>
                  This setting cannot be changed after creation
                </CheckboxTextLight>
              </CheckboxTextContainer>
            </CheckboxContainer>
          </InputContainer>

          <ButtonGroup>
            <CancelButton onClick={handleCancel} disabled={isLoading}>
              Cancel
            </CancelButton>
            <ConfirmButton
              onClick={handleConfirm}
              $type="primary"
              disabled={isLoading || !isNameValid}
            >
              {isLoading ? (
                <l-line-spinner size="20" stroke="2" speed="1" color="#000" />
              ) : (
                "Create"
              )}
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CreatePlaylistModal;
